import React, { useEffect, useState } from "react";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import { MAX_FILE_SIZE, MAX_FILE_SIZE_MESSAGE, isValidFileType } from "../../../../helpers/fileValidationRules";

const validationSchema = Yup.object().shape({
   emiStartDate: Yup.date().required("EMI Start Date is required"),
   emiEndDate: Yup.date().required("EMI End Date is required"),

   emiAmount: Yup.number()
      .required("EMI Amount is required")
      .min(0, "Must be a positive value"),

   emiCertificate: Yup.mixed()
      .required("EMI Certificate is required")
      .test("is-valid-type", "Not a valid document type", (value) => {
         return isValidFileType(value && value.name.toLowerCase(), "all");
      })
      .test(
         "is-valid-size",
         MAX_FILE_SIZE_MESSAGE,
         (value) => value && value.size <= MAX_FILE_SIZE
      ),

   financedBy: Yup.string().required("Financed By Name is required"),
});

const initialValues = {
   emiStartDate: "",
   emiEndDate: "",
   emiAmount: "",
   emiCertificate: null,
   financedBy: "",
};

function EmiForm({ handleFileChange, step2Data, setStep2Data, setCurrentTabIndex }) {
   const [initialState, setInitialState] = useState(initialValues);

   const handleNext = (formData) => {
      setCurrentTabIndex((prev) => prev + 1);
      setStep2Data(formData);
   };

   useEffect(() => {
      if (Object.keys(step2Data).length > 0) {
         setInitialState((prev) => ({ ...prev, ...step2Data }));
      }
   }, []);

   const formik = useFormik({
      initialValues: initialState,
      validationSchema: validationSchema,
      enableReinitialize: true,
      onSubmit: handleNext,
   });

   const { errors, touched, getFieldProps, handleSubmit, setFieldValue } = formik;

   return (
      <div
         className="tab-pane fade show active"
         id="1"
         role="tabpanel"
         aria-labelledby="1"
      >
         <div className="col-lg-12">
            <div className="card card-primary">
               <div className="card-header">
                  <h3 className="card-title">EMI</h3>
               </div>

               {/* Emi Sec */}
               <div className="row card-body">
                  <div className="col-lg-4">
                     <CustomDatePicker
                        require
                        label="EMI Start date"
                        placeholder="Enter vehicle owner name"
                        {...getFieldProps("emiStartDate")}
                        errors={
                           Boolean(touched.emiStartDate) && Boolean(errors.emiStartDate)
                        }
                        message={errors.emiStartDate}
                     />
                  </div>
                  <div className="col-lg-4">
                     <CustomDatePicker
                        require
                        label="EMI End date"
                        placeholder="Enter vehicle owner name"
                        {...getFieldProps("emiEndDate")}
                        errors={Boolean(touched.emiEndDate) && Boolean(errors.emiEndDate)}
                        message={errors.emiEndDate}
                     />
                  </div>
                  <div className="col-lg-4">
                     <CustomInput
                        require
                        label="EMI Amount"
                        id="emiAmount"
                        placeholder="Enter Amount"
                        {...getFieldProps("emiAmount")}
                        errors={formik.errors.emiAmount}
                        message={formik.errors.emiAmount}
                     />
                  </div>
                  <div className="col-lg-4">
                     <label className="text-bold">
                        EMI Certificate <span className="text-danger">*</span>
                     </label>
                     <CustomFileUpload
                        accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                        onChange={(event) => {
                           setFieldValue("emiCertificate", event?.target?.files?.[0]);
                        }}
                        errors={
                           Boolean(touched.emiCertificate) &&
                           Boolean(errors.emiCertificate)
                        }
                        message={errors.emiCertificate}
                     />
                  </div>
                  {/* Financed by sec */}
                  <div className="col-lg-4">
                     <CustomInput
                        require
                        label="Financed by"
                        id="#financedBy"
                        placeholder="Enter name"
                        {...getFieldProps("financedBy")}
                        errors={Boolean(touched.financedBy) && Boolean(errors.financedBy)}
                        message={errors.financedBy}
                     />
                  </div>
               </div>

               <div className="card-body">
                  <div
                     style={{
                        maxWidth: "min-content",
                        display: "flex",
                        marginLeft: "auto",
                     }}
                  >
                     <button
                        className="btn btn-secondary px-4 py-3"
                        type="button"
                        onClick={() => setCurrentTabIndex((prev) => prev - 1)}
                     >
                        <h6 className="mb-0 text-uppercase">Back</h6>
                     </button>
                     <button
                        className="btn btn-primary px-4 py-3 float-right ml-3"
                        type="button"
                        onClick={handleSubmit}
                     >
                        <h6 className="mb-0 text-uppercase">Next</h6>
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}

export default EmiForm;
